import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
type FaqProps = {
  items: {
    q: string;
    a: string;
  }[];
  tone?: 'dark' | 'light';
};
export function Faq({
  items,
  tone = 'dark'
}: FaqProps) {
  const [open, setOpen] = useState<number | null>(0);
  const dark = tone === 'dark';
  return <ul className={`border-t ${dark ? 'border-line' : 'border-ink/15'}`} data-id="element-254" data-mp="21l4924u51fud">
      {items.map((item, i) => {
      const isOpen = open === i;
      const id = `faq-${tone}-${i}`;
      return <li key={item.q} className={`border-b ${dark ? 'border-line' : 'border-ink/15'}`} data-id="element-255" data-mp="18vdqnjlh3rsg" data-mpi={i}>
            <button type="button" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? null : i)} className={`flex w-full items-center justify-between gap-6 py-6 text-left font-serif text-2xl md:text-3xl focus:outline-none focus-visible:ring-2 focus-visible:ring-amber ${dark ? 'text-paper' : 'text-ink'}`} data-id="element-256" data-mp="1dv9zpx9129ev">
              {item.q}
              <PlusIcon aria-hidden className={`h-5 w-5 shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''} ${dark ? 'text-amber' : 'text-amber-deep'}`} data-id="element-257" data-mp="2xov0b713afbc" />
            </button>
            <div id={id} className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-258" data-mp="2jqwrsi9g9d3r">
              <div className="overflow-hidden" data-id="element-259" data-mp="29ztrvjs9b462">
                <p className={`max-w-2xl pb-6 text-[17px] leading-relaxed ${dark ? 'text-sand' : 'text-ink/75'}`} data-id="element-260" data-mp="2520ikhvnpu1k">{item.a}</p>
              </div>
            </div>
          </li>;
    })}
    </ul>;
}